import { useQuery } from "@tanstack/react-query";
import { getBloomreachMappings } from "../../api/bBloomreachApi";

export const useGetBloomreachMappings = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["bloomreach-mappings", organisationId],
    queryFn: () => getBloomreachMappings(organisationId),
    enabled: Boolean(organisationId) && enabled,
  });
};
